import { FilterSetType } from '@/types/userConfigs';
import { useLocation } from 'react-router-dom';

// determines which filter set type to use based on the current URL
export const useFilterSetType = () => {
  const { pathname } = useLocation();

  if (pathname.includes('/data-locker/players')) return FilterSetType.PLAYER_DATA_LOCKER;
  if (pathname.includes('/data-locker/teams')) return FilterSetType.TEAM_DATA_LOCKER;
  if (pathname.includes('/data-locker/events')) return FilterSetType.EVENT_DATA_LOCKER;
  return FilterSetType.FILTERS;
};
